// @generated by protoc-gen-es v1.10.0
// @generated from file ai/h2o/mlops/storage/v1/project_service.proto (package ai.h2o.storage, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { FieldMask, proto3 } from "@bufbuild/protobuf";
import { Project } from "./project_pb.js";
import { FilterRequest, PagingRequest, PagingResponse, SortingRequest } from "./listing_pb.js";
import { Sharing } from "./sharing_pb.js";
import { AuditEvent } from "./audit_pb.js";

/**
 * @generated from message ai.h2o.storage.GetProjectRequest
 */
export const GetProjectRequest = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.GetProjectRequest",
  () => [
    { no: 1, name: "project_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message ai.h2o.storage.GetProjectResponse
 */
export const GetProjectResponse = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.GetProjectResponse",
  () => [
    { no: 1, name: "project", kind: "message", T: Project },
  ],
);

/**
 * @generated from message ai.h2o.storage.ListProjectsRequest
 */
export const ListProjectsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.ListProjectsRequest",
  () => [
    { no: 2, name: "paging", kind: "message", T: PagingRequest },
    { no: 3, name: "filter", kind: "message", T: FilterRequest },
    { no: 4, name: "sorting", kind: "message", T: SortingRequest },
  ],
);

/**
 * @generated from message ai.h2o.storage.ListProjectsResponse
 */
export const ListProjectsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.ListProjectsResponse",
  () => [
    { no: 1, name: "project", kind: "message", T: Project, repeated: true },
    { no: 2, name: "paging", kind: "message", T: PagingResponse },
    { no: 3, name: "user_project_count", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

/**
 * @generated from message ai.h2o.storage.ListProjectsContainingExperimentRequest
 */
export const ListProjectsContainingExperimentRequest = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.ListProjectsContainingExperimentRequest",
  () => [
    { no: 1, name: "experiment_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "paging", kind: "message", T: PagingRequest },
    { no: 3, name: "filter", kind: "message", T: FilterRequest },
    { no: 4, name: "sorting", kind: "message", T: SortingRequest },
  ],
);

/**
 * @generated from message ai.h2o.storage.ListProjectsContainingExperimentResponse
 */
export const ListProjectsContainingExperimentResponse = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.ListProjectsContainingExperimentResponse",
  () => [
    { no: 1, name: "project", kind: "message", T: Project, repeated: true },
    { no: 2, name: "paging", kind: "message", T: PagingResponse },
  ],
);

/**
 * @generated from message ai.h2o.storage.ListAllProjectsRequest
 */
export const ListAllProjectsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.ListAllProjectsRequest",
  () => [
    { no: 1, name: "paging", kind: "message", T: PagingRequest },
    { no: 2, name: "filter", kind: "message", T: FilterRequest },
    { no: 3, name: "sorting", kind: "message", T: SortingRequest },
  ],
);

/**
 * @generated from message ai.h2o.storage.ListAllProjectsResponse
 */
export const ListAllProjectsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.ListAllProjectsResponse",
  () => [
    { no: 1, name: "project", kind: "message", T: Project, repeated: true },
    { no: 2, name: "paging", kind: "message", T: PagingResponse },
    { no: 3, name: "total_project_count", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

/**
 * @generated from message ai.h2o.storage.CreateProjectRequest
 */
export const CreateProjectRequest = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.CreateProjectRequest",
  () => [
    { no: 1, name: "project", kind: "message", T: Project },
  ],
);

/**
 * @generated from message ai.h2o.storage.CreateProjectResponse
 */
export const CreateProjectResponse = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.CreateProjectResponse",
  () => [
    { no: 1, name: "project", kind: "message", T: Project },
  ],
);

/**
 * @generated from message ai.h2o.storage.UpdateProjectRequest
 */
export const UpdateProjectRequest = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.UpdateProjectRequest",
  () => [
    { no: 1, name: "project", kind: "message", T: Project },
    { no: 2, name: "update_mask", kind: "message", T: FieldMask },
  ],
);

/**
 * @generated from message ai.h2o.storage.UpdateProjectResponse
 */
export const UpdateProjectResponse = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.UpdateProjectResponse",
  () => [
    { no: 1, name: "project", kind: "message", T: Project },
  ],
);

/**
 * @generated from message ai.h2o.storage.DeleteProjectRequest
 */
export const DeleteProjectRequest = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.DeleteProjectRequest",
  () => [
    { no: 1, name: "project_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message ai.h2o.storage.ShareProjectRequest
 */
export const ShareProjectRequest = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.ShareProjectRequest",
  () => [
    { no: 2, name: "project_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "group_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "restriction_role_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message ai.h2o.storage.ShareProjectResponse
 */
export const ShareProjectResponse = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.ShareProjectResponse",
  () => [
    { no: 1, name: "sharing", kind: "message", T: Sharing },
  ],
);

/**
 * @generated from message ai.h2o.storage.UnshareProjectRequest
 */
export const UnshareProjectRequest = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.UnshareProjectRequest",
  () => [
    { no: 1, name: "project_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "sharing_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message ai.h2o.storage.UnshareProjectResponse
 */
export const UnshareProjectResponse = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.UnshareProjectResponse",
  [],
);

/**
 * @generated from message ai.h2o.storage.ListProjectEventsRequest
 */
export const ListProjectEventsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.ListProjectEventsRequest",
  () => [
    { no: 1, name: "project_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "paging", kind: "message", T: PagingRequest },
    { no: 3, name: "filter", kind: "message", T: FilterRequest },
    { no: 4, name: "sorting", kind: "message", T: SortingRequest },
  ],
);

/**
 * @generated from message ai.h2o.storage.ListProjectEventsResponse
 */
export const ListProjectEventsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.ListProjectEventsResponse",
  () => [
    { no: 1, name: "event", kind: "message", T: AuditEvent, repeated: true },
    { no: 2, name: "paging", kind: "message", T: PagingResponse },
    { no: 3, name: "event_count", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

/**
 * @generated from message ai.h2o.storage.ListProjectSharingsRequest
 */
export const ListProjectSharingsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.ListProjectSharingsRequest",
  () => [
    { no: 1, name: "project_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message ai.h2o.storage.ListProjectSharingsResponse
 */
export const ListProjectSharingsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.ListProjectSharingsResponse",
  () => [
    { no: 1, name: "sharing", kind: "message", T: Sharing, repeated: true },
  ],
);

/**
 * @generated from message ai.h2o.storage.TransferProjectOwnershipRequest
 */
export const TransferProjectOwnershipRequest = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.TransferProjectOwnershipRequest",
  () => [
    { no: 1, name: "project_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "new_owner_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message ai.h2o.storage.TransferProjectOwnershipResponse
 */
export const TransferProjectOwnershipResponse = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.TransferProjectOwnershipResponse",
  () => [
    { no: 1, name: "project_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "owner_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "status", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message ai.h2o.storage.BatchDeleteProjectRequest
 */
export const BatchDeleteProjectRequest = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.BatchDeleteProjectRequest",
  () => [
    { no: 1, name: "project_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message ai.h2o.storage.DeleteProjectResponse
 */
export const DeleteProjectResponse = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.DeleteProjectResponse",
  () => [
    { no: 1, name: "project_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "status", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message ai.h2o.storage.BatchDeleteProjectResponse
 */
export const BatchDeleteProjectResponse = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.BatchDeleteProjectResponse",
  () => [
    { no: 1, name: "projects_deleted", kind: "message", T: DeleteProjectResponse, repeated: true },
  ],
);

